/**
 * ------------------------------------------------
 
 * -------------------------------------------------
 */

/**
 * Root Service domain
 */
let root = "https://license-api.ustqe360.com/api/";
/**
 * UI
 */
//  let rootUi = "http://localhost:8080/"

export const environment = {
 production: true,
 root: root,
 baseUrl: root+'scriptless/rest/',
 deployUrl: root+'scriptless/beta/',
 // legacyUrl: rootUi,
 utilityUrl: 'https://noskript.com/',
 skriptmateUrl: root + 'scriptless/',
 
};